module.exports = __webpack_public_path__ + "img/checkbox.8776d715.svg";